import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-accordions="container"]',
        opener: '[js-accordions="opener"]',
        hiddenContent: '[js-accordions="hidden-content"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initAccordions()
    }

    function initAccordions() {
        $(nodeSelectors.opener).on('click', function () {

            if( !$(this).parent().hasClass('accordion--active') ) {
                $(nodeSelectors.hiddenContent).slideUp()
                $(nodeSelectors.opener).parent().removeClass('accordion--active')
            }

            $(this).parent().toggleClass('accordion--active').find(nodeSelectors.hiddenContent).slideToggle();
        })
    }

    return Object.freeze({
        init,
    })
}